function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ADMIN_SECTION } from "../../enum/ActionEnum";
import { BridgeBasic } from "../Basic";
export var ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["REDIRECT"] = "redirect";
  ACTION["ROUTER_REDIRECT"] = "routerRedirect";
  ACTION["ROUTER_TO_SPECIFIED_PAGE"] = "specifiedpage";
  return ACTION;
}({});
var Redirect = /*#__PURE__*/function (_BridgeBasic) {
  _inherits(Redirect, _BridgeBasic);
  var _super = _createSuper(Redirect);
  function Redirect(app) {
    var _this;
    _classCallCheck(this, Redirect);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "localOrigin", void 0);
    /**
     * 
     * @param url 
     */
    _defineProperty(_assertThisInitialized(_this), "replaceTo", function (url) {
      _this.dispatch(ACTION.REDIRECT, {
        payLoad: {
          redirectUrl: url
        }
      });
    });
    /**
     * 
     * @param url 
     */
    _defineProperty(_assertThisInitialized(_this), "routerTo", function (url) {
      _this.dispatch(ACTION.ROUTER_REDIRECT, {
        payLoad: {
          redirectUrl: url
        }
      });
    });
    /**
     * 
     * @param params 
     * newContext 
     * url
     */
    _defineProperty(_assertThisInitialized(_this), "navigate", function (params) {
      _this.dispatch(ACTION.REDIRECT, {
        payLoad: _objectSpread({}, params)
      });
    });
    /**
     * 
     * @param section admin specified page
     * @param params 
     */
    _defineProperty(_assertThisInitialized(_this), "ToAdminPage", function (section, params) {
      var payLoad = _objectSpread({
        section: section
      }, params);
      if (!(section.toUpperCase() in ADMIN_SECTION)) {
        console.error("[appbridge] ACTION execution failed. Please check whether your parameters[ADMIN_SECTION] are incorrect. ");
        return;
      }
      _this.dispatch(ACTION.ROUTER_TO_SPECIFIED_PAGE, {
        payLoad: payLoad
      });
    });
    _this.dispatch = app.dispatch;
    _this.subscribe = app.subscribe;
    _this.unsubscribe = app.unsubscribe;
    _this.localOrigin = app.localOrigin;
    return _this;
  }
  return _createClass(Redirect);
}(BridgeBasic);
function create(app) {
  return new Redirect(app);
}
export { create, Redirect, ADMIN_SECTION };